import { Box, styled } from '@creditas-ui/react'
import React from 'react'

const ContainerDetailsStyle = styled(Box)`
  display: flex;
  margin: 0 auto;
  margin: 50px 0;
  justify-content: space-between;
  flex-direction: column-reverse;
  padding: 0 20px;

  @media screen and (min-width: 980px) {
    margin: 0;
    padding: 3rem 5rem;
    flex-direction: row;

    > div:first-of-type {
      margin-right: 40px;
    }
  }
`

const ContainerDetails = ({ children, ...props }) => {
  return (
    <ContainerDetailsStyle component="div" {...props}>
      {children}
    </ContainerDetailsStyle>
  )
}

export { ContainerDetails }
